module.exports = __webpack_public_path__ + "media/waiting-room-12.4399cb4e.mp4";